import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase } from '@mui/material';

// project imports
import LogoSection from '../LogoSection';
import ProfileSection from './ProfileSection';
import LanguageButton from 'ui-component/LanguageButton';
import { DEMO_MODE_ENABLED } from 'constants/demoMode';
import DemoModeBanner from 'ui-component/DemoModeBanner';
import ReadOnlyBanner from 'ui-component/ReadOnlyBanner';
import { isReadOnlyAdmin } from 'utils/common';
import { useSelector } from 'react-redux';


// assets
import { IconMenu2 } from '@tabler/icons-react';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
  const theme = useTheme();
  const role = useSelector((state) => state.account && state.account.user && state.account.user.role);
  const readOnly = role != null && role !== '' ? Number(role) >= 9 && Number(role) < 10 : isReadOnlyAdmin();

  return (
    <>
      {/* logo & toggler button */}
      <Box
        sx={{
          width: 228,
          display: 'flex',
          [theme.breakpoints.down('md')]: {
            width: 'auto'
          }
        }}
      >
        <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
          <LogoSection />
        </Box>
        <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              ...theme.typography.menuButton,
              transition: 'all .2s ease-in-out',
              '&:hover': {
                background: theme.palette.secondary.dark,
                color: theme.palette.secondary.light
              }
            }}
            onClick={handleLeftDrawerToggle}
            color="inherit"
          >
            <IconMenu2 stroke={1.5} size="1.3rem" />
          </Avatar>
        </ButtonBase>
      </Box>

      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />
      {readOnly && (
        <Box sx={{ mr: 1.5 }}>
          <ReadOnlyBanner />
        </Box>
      )}
      {DEMO_MODE_ENABLED && (
        <Box sx={{ mr: 1.5 }}>
          <DemoModeBanner />
        </Box>
      )}
      <LanguageButton />
      <ProfileSection />
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func
};

export default Header;
